import React from 'react';
import Footer from '../../layout/footers/footer';
import Header from '../../layout/headers/header';
import AssistirMaisTardeArea from '../assistir-mais-tarde/assistir-mais-tarde-area';

const index = () => {
  return (
    <>
      {/* header start */}
      <Header header_shadow={true} />
      {/* header end */}

      {/* sign in area start */}
      <AssistirMaisTardeArea />
      {/* sign in area end */}

      {/* footer area start */}
      <Footer pt="pt-90" />
      {/* footer area end */}
    </>
  );
};

export default index;